import { Translate } from "components/common/Translate/Translate";
import { applySettingsToAll } from "store/features/memeGenerator/actions";
import { useAppDispatch } from "store/store";

interface ApplyToAllProps {
    textBoxId: string;
}

export const ApplyToAll = ({ textBoxId }: ApplyToAllProps) => {
    const dispatch = useAppDispatch();
    function handleClick() {
        dispatch(applySettingsToAll(textBoxId));
    }
    return (
        <button
            className="py-2 border border-irGray-200 dark:border-darkSurface-400 dark:bg-darkSurface-200 rounded-[10px] text-center hover:bg-irGray-100 w-full"
            onClick={handleClick}
        >
            <Translate keyName="apply-to-all-fonts" />
        </button>
    );
};
